export default __webpack_public_path__ + "static/media/CONTI_Loyalty_Program_Werbetrailer_sec22.385e3c2e.jpg";